import { render, staticRenderFns } from "./CreateAccountFormContact.vue?vue&type=template&id=bbdda576&"
import script from "./CreateAccountFormContact.vue?vue&type=script&lang=js&"
export * from "./CreateAccountFormContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports